import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import Modal from "../../../component/Global/Modal";
import BOM from "@system/config/bom";
import { useBOMStore } from "src/hooks/bom";
import $ from "jquery";
import System from "../../../helper/system";
import { applyFilterByMainKeyAndSlug, clearAllFilter } from "../../../store/slice/ProductListingFilterApplied";
import Helper from "../../../support/Helper";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import AxiosIndicatorRunTimeLoader from "../../../component/AxiosIndicatorRunTimeLoader";
import { isArray } from "underscore";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const FindPartPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const dispatch = useDispatch();
    const [status, SetStatus] = useState(false);
    const [startLoader, SetStartLoader] = useState(false);
    const [displaySearchSelectedCatNameForAlert, SetDisplaySearchSelectedCatNameForAlert] = useState('');
    const [levelsUserIsInCount, SetLevelsUserIsInCount] = useState(0);
    const [product_category_list, set_product_category_list] = useState({});
    const [display_product_category_list, set_display_product_category_list] = useState([]);
    const [{ FindPartPopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ }, { fetch_product_category_list }, { create_blank_bom }] = useBOMStore();
    const { data } = props;
    const add_from = props?.data?.addFrom;
    const bom_id = System.getParams().bomId

    useEffect(() => {
        if (FindPartPopup) {
            SetStatus(true)
        }
    }, [FindPartPopup]);
    useEffect(() => {
        async function fetchHere() {
            let f = await fetch_product_category_list();
            set_product_category_list(f.payload)
        }

        if (status) {
            fetchHere()
        }
    }, [status]);
    useEffect(() => {
        async function fetchHere() {
            setInitialCategoriesListing()
        }

        if (status) {
            fetchHere()
        }
    }, [product_category_list]);
    const onHide = (action = true) => {
        SetStatus(false)
    };

    const takeActionAgainstUserSelection = async (single_selected_category) => {
        let c = System.getParams();
        c.go = '';
        await history.pushState(null, null, '?' + $.param(c));
        let l = levelsUserIsInCount + 1;
        dispatch(clearAllFilter());
        SetLevelsUserIsInCount(l);
        if (levelsUserIsInCount === 0 || (single_selected_category.Categories !== undefined && single_selected_category.Categories.length > 0)) {
            SetDisplaySearchSelectedCatNameForAlert(single_selected_category.Name);
            // No Match Display Search parameter is Manufacturer Part Number
            if (validateNoMatch()) {
                SetDisplaySearchSelectedCatNameForAlert(data.manufacturerPartNumber);
            }
            if (single_selected_category.Categories !== undefined && isArray(single_selected_category.Categories)) {
                set_display_product_category_list(single_selected_category.Categories)
            }
        } else {
            if (single_selected_category.value) {
                SetStartLoader(true);
                let k = {
                    key: "Categories",
                    main_label: "Categories",
                    value: single_selected_category.value
                };
                if (single_selected_category.level !== undefined) {
                    k.hidden_payload = {
                        Level: single_selected_category.level,
                        partNumber: validateNoMatch() ? data.manufacturerPartNumber : ''
                    };
                }
                if (bom_id !== undefined && bom_id !== '') {
                    dispatch(applyFilterByMainKeyAndSlug(k));
                    window.location.href = BOM.getBomProductListingRouteURL(
                        bom_id,
                        {
                            go: System.getParams().go,
                            addFrom:add_from,
                            ...FindPartPopup.data
                        }
                    );
                } else {
                    let add_bom = await create_blank_bom();
                    if (add_bom.payload !== undefined &&
                        add_bom.payload.data !== undefined
                    ) {
                        dispatch(applyFilterByMainKeyAndSlug(k));
                        window.location.href = BOM.getBomProductListingRouteURL(
                            add_bom.payload.data,
                            {
                                redirect_back_url: location.href,
                                addFrom:add_from,
                                go: System.getParams().go
                            }
                        );
                    }
                }
            }
        }
    };

    const setInitialCategoriesListing = () => {
        if (product_category_list && product_category_list.Categories !== undefined && isArray(product_category_list && product_category_list.Categories)) {
            set_display_product_category_list(product_category_list.Categories)
        }
        SetLevelsUserIsInCount(0);
    };

    const validateNoMatch = () => {
        if (!__check(['BOM_PRODUCT_CATEGORY_API_CALL']).status &&
            data !== undefined &&
            data !== null &&
            data.no_match !== undefined &&
            data.no_match === true &&
            data.manufacturerPartNumber !== undefined &&
            data.manufacturerPartNumber !== null &&
            data.manufacturerPartNumber.trim() !== '') {
            return true;
        }
        return false;
    }
    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal avnet-modal-right find-parts">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-2" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header">
                            <h4 onClick={() => {
                                setInitialCategoriesListing()
                            }}
                                className="modal-title text-center" id="myModalLabel">FIND A PART</h4>
                        </div>
                        <div className="modal-body">

                            {__check(['BOM_PRODUCT_CATEGORY_API_CALL']).render}
                            {!__check(['BOM_PRODUCT_CATEGORY_API_CALL']).status && startLoader &&
                                <AxiosIndicatorRunTimeLoader />
                            }
                            {validateNoMatch() && data.search_param!=='' &&
                                <div className="alert alert-info m-b-30 d-block">
                                    You searched for <b> {data.search_param}, </b> Find a Part starts with
                                    selecting a category.
                                </div>
                            }

                            {levelsUserIsInCount === 0 &&
                                <>
                                    <h3 className='mb-3' onClick={() => {
                                        setInitialCategoriesListing()
                                    }}>Categories</h3>
                                </>
                            }
                            {levelsUserIsInCount >= 1 &&
                                <>
                                    {validateNoMatch() === false &&
                                        <div className="alert alert-info m-b-30">
                                            <span> You searched for {displaySearchSelectedCatNameForAlert}, Find a Part starts with
                                                selecting a sub-category</span>
                                        </div>
                                    }

                                    <a className="me-3 mb-1 d-block text-blue2" href={void (0)}
                                        onClick={() => {
                                            setInitialCategoriesListing()
                                        }}
                                    >
                                        <i className="fa fa-angle-double-left me-2" aria-hidden="true" />
                                        Back
                                    </a>
                                    <h3 className='mb-3'>Sub-Categories</h3>
                                    {validateNoMatch() === false &&
                                        <h5 className='m-b-10'>{displaySearchSelectedCatNameForAlert}</h5>
                                    }
                                </>
                            }

                            {!__check(['BOM_PRODUCT_CATEGORY_API_CALL']).status &&
                                <ul className={levelsUserIsInCount >= 1 ? "ms-2" : ""}>
                                    {isArray(display_product_category_list) && display_product_category_list.length > 0 &&
                                        display_product_category_list.map((v) => (
                                            <li key={Helper.UUID()} className="mb-2">
                                                <a href={void (0)} onClick={async () => {
                                                    await takeActionAgainstUserSelection(v)
                                                }} className="text-blue2 font-bold">
                                                    {v.Name}
                                                </a>
                                            </li>
                                        ))
                                    }
                                </ul>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default FindPartPopup;